(() => {
  const rootSelector = '[data-valmonti-menu]';

  function initialize(root = document) {
    root.querySelectorAll('.valmonti-header__dropdown').forEach((dropdown) => {
      if (dropdown.dataset.valmontiDesktopDropdown === 'true') return;
      dropdown.dataset.valmontiDesktopDropdown = 'true';

      const desktop = window.matchMedia('(min-width: 700px)');
      dropdown.addEventListener('pointerenter', () => {
        if (desktop.matches) dropdown.setAttribute('open', '');
      });
      dropdown.addEventListener('pointerleave', () => {
        if (desktop.matches) dropdown.removeAttribute('open');
      });
      dropdown.addEventListener('focusout', (event) => {
        if (desktop.matches && !dropdown.contains(event.relatedTarget)) dropdown.removeAttribute('open');
      });
    });

    root.querySelectorAll(rootSelector).forEach((menu) => {
      if (menu.dataset.valmontiInitialized === 'true') return;
      menu.dataset.valmontiInitialized = 'true';

      menu.querySelectorAll('[data-valmonti-menu-back]').forEach((button) => {
        button.addEventListener('click', () => button.closest('.valmonti-header__mobile-submenu')?.removeAttribute('open'));
      });

      menu.querySelectorAll('.valmonti-header__menu-link[href]').forEach((link) => {
        link.addEventListener('click', () => menu.removeAttribute('open'));
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !menu.open) return;
        const openSubmenu = menu.querySelector('.valmonti-header__mobile-submenu[open]');
        if (openSubmenu) openSubmenu.removeAttribute('open');
        else menu.removeAttribute('open');
      });
    });

    root.querySelectorAll('[data-valmonti-cart-trigger]').forEach((trigger) => {
      if (trigger.dataset.valmontiCartInitialized === 'true') return;
      trigger.dataset.valmontiCartInitialized = 'true';

      const cartDrawer = document.getElementById('cart-drawer');
      trigger.setAttribute('aria-expanded', cartDrawer?.hasAttribute('open') ? 'true' : 'false');
    });
  }

  function syncCartDrawerState(event) {
    if (event.target?.id !== 'cart-drawer') return;
    const isOpen = event.type === 'theme-drawer:open';
    document.querySelectorAll('[data-valmonti-cart-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(isOpen));
    });
  }

  function updateCartCount(count) {
    const normalizedCount = Math.max(0, Number(count) || 0);

    document.querySelectorAll('[data-valmonti-cart-count]').forEach((node) => {
      node.textContent = String(normalizedCount);
    });

    document.querySelectorAll('[data-valmonti-cart-count-badge]').forEach((badge) => {
      badge.textContent = normalizedCount > 99 ? '99+' : String(normalizedCount);
      badge.hidden = normalizedCount === 0;
    });

    document.querySelectorAll('.valmonti-header__action--cart').forEach((action) => {
      action.setAttribute('aria-label', `Cart, ${normalizedCount} items`);
    });
  }

  document.addEventListener('theme-drawer:open', syncCartDrawerState);
  document.addEventListener('theme-drawer:close', syncCartDrawerState);
  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise
      ?.then(({ cart, detail }) => updateCartCount(cart?.totalQuantity ?? detail?.itemCount ?? 0))
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[valmonti-header] Cart update failed:', error);
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
